module.exports = __webpack_public_path__ + "img/template-05.126c570c.jpg";